// extracted by mini-css-extract-plugin
export var actualiteCategorie = "actualites-module--actualite-categorie--71d0a";
export var actualiteContainer = "actualites-module--actualiteContainer--797c4";
export var actualiteContainerFirst = "actualites-module--actualiteContainerFirst--324de";
export var actualiteInfos = "actualites-module--actualite-infos--e1287";
export var actualiteResume = "actualites-module--actualite-resume--3c35e";
export var actualiteTitle = "actualites-module--actualite-title--ac4bc";
export var actualitesContainer = "actualites-module--actualites-container--ac7bd";
export var actualitesDescription = "actualites-module--actualites-description--e06aa";
export var autresActualites = "actualites-module--autres-actualites--f3609";
export var editButtonFirstActu = "actualites-module--edit-button-first-actu--c2eb8";
export var editButtonTitle = "actualites-module--edit-button-title--9e466";
export var listActualitesContainer = "actualites-module--list-actualites-container--325a6";
export var listActualitesTitle = "actualites-module--list-actualites-title--c405d";